import BIForm from './form';
import Route from '../route';

$(function () {
    const StorageModal = $(`#storageFormEdit`);
    const FormId = "#storageLocationForm";

    let $modalSpinner = $(".loading", StorageModal);

    $('#storageFormEdit form').attr('id', FormId.substring(1)); // set form ID for update
    $(FormId).attr('method', 'PATCH');

    $('.form-fields', FormId).addClass('d-none');

    let StorageFormCreate = new BIForm({
        form_id: '#addStorageLocationForm'
    });

    // Add form submit listener and callback
    StorageFormCreate.addSubmitListener((response) => {
        window.location.reload();
    });

    if (Route === ("storage-locations")) {
        // Remove button click
        $(".storage-table .remove-item").on("click", function () {
            $("body").css("cursor", "progress");
            let id = $(this).data("id");
            axios
                .delete('/account/storage-locations/delete/' + id)
                .then(function (response) {
                    if (response.data.success === true) {
                        if ($('.storage-table tbody tr').length === 1) {
                            location.reload();
                        } else {
                            $('.storage-table tr[data-id="' + id + '"]').remove();
                        }
                    } else {
                        var message = response.data.message;
                        console.log(message);
                        $('#generic-error').on('shown.bs.modal', function () {
                            setTimeout(function () {
                                $("#error-message").html(message);
                            }, 10);
                        }).modal('show');
                    }
                    $("body").css("cursor", "default");
                })
                .catch(function (error) {
                    StorageForm.showErrors(error.response.data);
                    $("body").css("cursor", "default");
                });
        });

        let StorageForm = new BIForm({
            form_id: FormId,
            read_url: `/account/storage-locations/read`,
        });

        // Add form submit listener and callback
        StorageForm.addSubmitListener((response) => {
            window.location.reload();
        });

        // When modal opens, load the data
        StorageModal.on("shown.bs.modal", function (e) {
            let id = null;
            let button = e.relatedTarget;

            StorageForm.hideDropdown('add_lookuplist');

            if ($(button).hasClass("edit")) {
                $modalSpinner.removeClass('d-none');
                id = $(button).data("id");
                StorageForm.setAction("/account/storage-locations/update/" + id);

                // Loads the data into the StorageModal Form
                StorageForm.populateFields(id, (form, data) => {
                    $modalSpinner.addClass("d-none");
                    $(".form-fields", StorageModal).removeClass("d-none");
                    $('input[type="checkbox"]', FormId).val('on');

                    if (data.displayName === 'Bordeaux Index Client Reserves') {
                        $('input[name="displayName"]', form)
                            .addClass('disabled')
                            .prop('readonly', true);
                        $('select[name="stockLocationId"]', form)
                            .prop('readonly', true)
                            .siblings('.select-options')
                            .css('visibility', 'hidden');
                    } else {
                        $('input[name="displayName"]', form)
                            .removeClass('disabled')
                            .prop('readonly', false);
                        $('select[name="stockLocationId"]', form)
                            .prop('readonly', false)
                            .siblings('.select-options')
                            .css('visibility', 'visible');
                    }
                });
            } else {
                StorageForm.setAction("/account/storage-locations/create");
                $(".form-fields", StorageModal).removeClass("d-none");
            }
        }).on("hidden.bs.modal", function () {
            $(".form-fields", this).addClass("d-none");
            $modalSpinner.addClass("d-none");
            StorageForm.emptyForm();

            $(".invalid-feedback").css("display", "none");
            $(FormId).find('.is-invalid').removeClass('is-invalid');
        });
    }


    // Add asterick if Other is selected
    var stockLocation = $('#stockLocationId');
    var accountRefLabel = $('label[for="accountRef"]');
    accountRefLabel.find('span.asterisk').hide();

    stockLocation.on('change', function () {
        var stockLocationSelected = stockLocation.find(":selected").text();

        if (stockLocationSelected.trim() == "Other - please specify") {
            accountRefLabel.find('span.asterisk').remove();
            accountRefLabel.append('<span class="asterisk"> *</span>');
            $("#accountRefTooltip").html('This is your reference at your storage location only. <span class="close"></span>');
        } else {
            accountRefLabel.find('span.asterisk').remove();
            $("#accountRefTooltip").html('This is your reference at your storage location. This is not mandatory to complete. <span class="close"></span>');
        }
    });
});
